import { gql } from "@apollo/client";

export const PRICE_DATA_FIELDS = gql`
  fragment PriceDataFields on TenantPriceData {
    id
    startingPrice {
      smsSegmentPriceInMillicents
      mmsMessagePriceInMillicents
      smsUnregisteredSegmentPriceInMillicents
      mmsUnregisteredMessagePriceInMillicents
      smsShortcodeSegmentPriceInMillicents
      mmsShortcodeMessagePriceInMillicents
    }
    overrides {
      id
      smsSegmentPriceInMillicents
      mmsMessagePriceInMillicents
      smsUnregisteredSegmentPriceInMillicents
      mmsUnregisteredMessagePriceInMillicents
      smsShortcodeSegmentPriceInMillicents
      mmsShortcodeMessagePriceInMillicents
      startDate
    }
    currentPrice {
      smsSegmentPriceInMillicents
      mmsMessagePriceInMillicents
      smsUnregisteredSegmentPriceInMillicents
      mmsUnregisteredMessagePriceInMillicents
      smsShortcodeSegmentPriceInMillicents
      mmsShortcodeMessagePriceInMillicents
    }
  }
`;

export const CREATE_PRICE_OVERRIDE = gql`
  ${PRICE_DATA_FIELDS}
  mutation createPriceOverride($input: CreatePriceOverrideInput!) {
    createPriceOverride(input: $input) {
      ...PriceDataFields
    }
  }
`;

export const DELETE_PRICE_OVERRIDE = gql`
  ${PRICE_DATA_FIELDS}
  mutation deletePriceOverride($input: DeletePriceOverrideInput!) {
    deletePriceOverride(input: $input) {
      ...PriceDataFields
    }
  }
`;

export const EDIT_STARTING_PRICE_OVERRIDE = gql`
  ${PRICE_DATA_FIELDS}
  mutation editStartingPriceOverride($input: EditStartingPriceOverrideInput!) {
    editStartingPriceOverride(input: $input) {
      ...PriceDataFields
    }
  }
`;

export const PRICE_DATA_QUERY = gql`
  ${PRICE_DATA_FIELDS}
  query getTenantPriceData {
    getTenantPriceData {
      ...PriceDataFields

      defaults {
        smsSegmentPriceInMillicents
        mmsMessagePriceInMillicents
        smsUnregisteredSegmentPriceInMillicents
        mmsUnregisteredMessagePriceInMillicents
        smsShortcodeSegmentPriceInMillicents
        mmsShortcodeMessagePriceInMillicents
      }
    }
  }
`;
